import { useAppSelector } from "redux/hooks";
import { selectClient } from "redux/slices/session";
import { P } from "theme/typography";
import { useContext } from "react";
import { PortalContext } from "contexts/PortalContext";
import { createPortal } from "react-dom";
import { Config } from "Config";

export const LensEditorBreadcrumb = () => {
  const client = useAppSelector(selectClient);

  const logoUrl = Config.backendBase + `/client/getAsset/logo_banner.png`;

  const clientNameAndId = client?.name ? `${client.name} (${client.id})` : "...";

  const { portalRefElement } = useContext(PortalContext);

  return (
    <>
      {portalRefElement && createPortal(<img className="h-[30px]" src={logoUrl} alt=""></img>, portalRefElement)}
      <P sx={{ mr: 1 }}>{clientNameAndId}</P>
    </>
  );
};
